export default __webpack_public_path__ + "static/media/ai-agents.802866a1.png";